import React from "react";
import moment from "moment";

import FlightResultCard from "./FlightResultCard";

const ACCENT = "var(--btn-bg)";

const FlightSearchResults = ({ results, loading, searched, search, onBook }) => {
  const pax = search?.pax_detail;
  const visible = results;

  if (!searched && !loading) {
    return (
      <div className="fr-empty">
        <i className="bi bi-airplane-engines" style={{ fontSize: 40, color: ACCENT }}></i>
        <div className="fr-empty-title">Find the best fares</div>
        <div className="fr-muted">Choose your route, dates and travellers above, then press Search.</div>
      </div>
    );
  }

  const s = search?.sector;
  const travellers = (pax?.adults || 0) + (pax?.children || 0) + (pax?.infants || 0);

  return (
    <div>
      {/* Results */}
      <div>
        {s && (
          <div className="fr-summary">
            <div>
              <div className="fr-heading" style={{ fontSize: 20 }}>
                Series Inventory
                {!loading && (
                  <span className="ms-2" style={{ fontSize: 12, fontWeight: 600, background: "#d9efea", color: "var(--btn-bg)", borderRadius: 999, padding: "2px 10px" }}>
                    {visible.length} found
                  </span>
                )}
              </div>
            </div>
            <div className="fr-heading">
                {s.origin} &rarr; {s.destination} {" | "} {moment(s.departure_date).format("ddd, D MMM YYYY")}
                {s.return_date ? ` - ${moment(s.return_date).format("ddd, D MMM YYYY")}` : ""}
                {" | "} <span> <span style={{ color: "#2563eb" }}> {pax?.adults || 0} Adult{pax?.adults !== 1 ? "s" : ""} </span>{" "} <span style={{ color: "#16a34a" }}> {pax?.children || 0} Child{pax?.children !== 1 ? "ren" : ""} </span>{" "} <span style={{ color: "#ea580c" }}> {pax?.infants || 0} Infant{pax?.infants !== 1 ? "s" : ""} </span> </span> {" | "} {s.cabin_class}
                {/* {" "}&middot; {travellers} Traveller{travellers > 1 ? "s" : ""} &middot; {s.cabin_class} */}
            </div>
          </div>
        )}

        {loading ? (
          [1, 2, 3].map((i) => <div key={i} className="fr-card fr-skeleton" />)
        ) : visible.length == 0 ? (
          <div className="fr-empty">
            <i className="bi bi-emoji-frown" style={{ fontSize: 36, color: "#94a3b8" }}></i>
            <div className="fr-empty-title">No flights found</div>
            <div className="fr-muted">
              Try another date or route.
            </div>
          </div>
        ) : (
          visible.map((fare) => <FlightResultCard key={fare.fare_reference_code} fare={fare} pax={pax} routeType={search?.route_type} onBook={onBook} />)
        )}
      </div>
    </div>
  );
};

export default FlightSearchResults;
